import { Icon } from '@iconify/react';
import { AnimatePresence, motion } from 'framer-motion';
import { Fragment, useEffect, useState } from 'react';
import { Colors, Fonts } from '../../../config/theme';
import ShowImage from '../../../components/show_image';
import { Col, Row, Modal as BootStrapModal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { ListingItem, Listing } from '../../../data/types/listings';
import {
  AttributeType,
  BaseBooleanAttribute,
  BaseNumericAttribute,
  BaseSelectAttribute,
} from '../../../data/types/attributes';
import { AttributeAssociation } from '../../../data/types/listings';
import { ImageType } from '../../../data/types/files';
import {
  formatAttributeName,
  formatAttributeValues,
  formatDecimals,
  formatPrice,
} from '../../../utils/functions/formatting_functions';
import Spinner from '../../../components/spinner';
import { formateServerDateToLocaleDate } from '../../../utils/functions/time_date_functions';
import { canChangeStockAndPrice } from '../functions/listing_profile_functions';
import { sanitizeHTML } from '../../../utils/functions/formatting_functions';
import React from 'react';
import { SanitizedHTMLStyle } from '../../../styles/style';
import Lightbox from 'react-image-lightbox';
import { EN_AR_TRANSLATION_SPLIT_CHAR } from '../../../pages/create_listings/constants';
import { PopupWithConfirmation } from '../../../components/popups';
import { toast } from 'react-toastify';
import { UpdateNameOrDescriptionModal } from '../modals/update_name_desc_modal';
import { FaPencil } from 'react-icons/fa6';
import SharedRepository from '../../../data/repositories/shared_repository';
import {
  Autocomplete,
  AutocompleteItem,
  Button,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Switch,
  useDisclosure,
} from '@nextui-org/react';
import { DiscountType } from '../../../data/types/promotions';

const SECTIONS = {
  REJECTION_INFORMATION: 1,
  ITEM_INFORMATION: 2,
  ATTRIBUTES: 3,
  COMBINATION_TABLE: 4,
  PROMOTION: 5,
  SHIPPING: 6,
};

export default function ListingDetailsView({
  listingDetails,
  categoriesRepository,
  dataEditingRepository,
  actionUpdateListingStockAndPrice,
  categoryName,
}: {
  listingDetails: Listing;
  categoriesRepository?: any;
  dataEditingRepository?: any;
  actionUpdateListingStockAndPrice?: (payload: any) => {
    type: string;
    payload: any;
  };
  categoryName: string;
}) {
  const dispatch = useDispatch();

  const [lists, setList] = useState([
    SECTIONS.REJECTION_INFORMATION,
    SECTIONS.ITEM_INFORMATION,
    SECTIONS.ATTRIBUTES,
    SECTIONS.COMBINATION_TABLE,
    SECTIONS.PROMOTION,
    SECTIONS.SHIPPING,
  ]);
  const [same_attributes, setSameAttributes] = useState<string[]>([]);
  const [listing, setListing] = useState(listingDetails);
  const [image_modal, set_image_modal] = useState(false);

  const [index, setIndex] = useState(-1);
  const image = listing?.images?.[index];
  const currentImage = listing?.images?.[index];
  const nextIndex = (index + 1) % listing?.images?.length;
  const nextImage = listing?.images?.[nextIndex] || currentImage;
  const prevIndex =
    (index + listing?.images?.length - 1) % listing?.images?.length;
  const prevImage = listing?.images?.[prevIndex] || currentImage;
  const handleClick = (index: number) => setIndex(index);
  const handleClose = () => {
    setIndex(-1);
  };
  const handleMovePrev = () => setIndex(prevIndex);
  const handleMoveNext = () => setIndex(nextIndex);

  const openLightBox = (index: number) => {
    handleClick(index);
    setIndex(index);
  };

  useEffect(() => {
    setSameAttributes(
      listingDetails?.items[0].attributes?.map((i) => i.attr_name_en),
    );
    setListing(listingDetails);
  }, [listingDetails]);

  const toggleCollapse = (number: number) => {
    if (lists.includes(number)) {
      setList(lists.filter((i) => i !== number));
    } else {
      setList([...lists, number]);
    }
  };

  const zoomImage = (image: ImageType) => {
    openLightBox(listing.images.findIndex((i) => i.id === image.id));
  };

  const closeImageModal = () => {
    set_image_modal(false);
  };

  const handleChangeInStockAndPrice = (
    item: ListingItem,
    price?: string,
    inStock?: boolean,
  ) => {
    const payload = {
      data: {
        items: [
          {
            item_id: item.id,
            price: price || item.original_price,
            in_stock: inStock,
          },
        ],
      },
      success: () => {
        listing.items.map((dataItem) => {
          if (dataItem.id === item.id) {
            if (price) {
              dataItem.price = price;
            } else {
              dataItem.in_stock = !dataItem.in_stock;
            }
          }
          return dataItem;
        });
        setListing({ ...listing });
      },
    };
    dispatch(actionUpdateListingStockAndPrice!(payload));
  };
  return listing === undefined ? (
    <Spinner />
  ) : (
    <div>
      {image && (
        <Lightbox
          mainSrc={image.public_s3_url}
          imageTitle={`# ${currentImage.id} ` + (image.alt || 'No Alt Text')}
          mainSrcThumbnail={image.public_s3_url}
          nextSrc={
            nextImage.public_s3_url || nextImage.get_object_presigned_url
          }
          nextSrcThumbnail={nextImage.alt}
          prevSrc={
            prevImage.public_s3_url || prevImage.get_object_presigned_url
          }
          prevSrcThumbnail={prevImage.alt}
          onCloseRequest={handleClose}
          onMovePrevRequest={handleMovePrev}
          onMoveNextRequest={handleMoveNext}
        />
      )}
      <BootStrapModal
        className="d-flex justify-content-center image-modal"
        show={image_modal}
        onHide={() => closeImageModal()}
        centered
      >
        <div>
          <ShowImage
            style={{
              height: '500px',
              width: '400px',
              borderRadius: '30px',
            }}
            image={image!}
          />
        </div>
      </BootStrapModal>

      <div className="container">
        <motion.div className="left-side">
          <div className="grid-row-three">
            {listing?.request?.status_name === 'rejected' &&
              RejectionInformationSection(toggleCollapse, lists, listing)}

            {ItemInformationSection(
              toggleCollapse,
              lists,
              listing,
              zoomImage,
              categoryName,
              dataEditingRepository,
            )}

            {AttributesSection(
              toggleCollapse,
              categoriesRepository,
              lists,
              listing,
              zoomImage,
            )}

            {CombinationTableSection(
              toggleCollapse,
              lists,
              same_attributes,
              listing,
              handleChangeInStockAndPrice,
              zoomImage,
              actionUpdateListingStockAndPrice === undefined,
            )}

            {PromotionSection(toggleCollapse, lists, listing)}

            {ShippingSection(toggleCollapse, lists, listing)}
          </div>
        </motion.div>
      </div>
    </div>
  );
}

function RejectionInformationSection(
  toggleCollapse: (number: number) => void,
  lists: number[],
  listing: Listing,
) {
  return (
    <div className="grid-column">
      <button
        style={{ fontFamily: Fonts.secondary }}
        onClick={() => toggleCollapse(SECTIONS.REJECTION_INFORMATION)}
      >
        Rejection information
        <span>
          {lists.includes(SECTIONS.REJECTION_INFORMATION) ? (
            <Icon icon="akar-icons:chevron-up" />
          ) : (
            <Icon icon="akar-icons:chevron-down" />
          )}
        </span>
      </button>
      <AnimatePresence initial={false}>
        {lists.includes(SECTIONS.REJECTION_INFORMATION) && (
          <motion.div
            className="dataPanel"
            initial="closed"
            animate="open"
            exit="closed"
            variants={{
              open: { opacity: 1, height: 'auto' },
              closed: { opacity: 0, height: 0 },
            }}
            transition={{
              duration: 0.3,
              ease: [0.4, 0.62, 0.23, 0.4],
            }}
          >
            <div className="customer-info row-2 secondary-font">
              <div className="row">
                <p className="left-column">Rejection notes: </p>
                <p className="right-column">
                  {listing?.request?.response?.msg}
                </p>
              </div>
              <div className="row">
                <p className="left-column">Rejected on:</p>
                <p className="right-column">
                  {formateServerDateToLocaleDate(
                    listing?.request?.response?.response_date ?? '',
                  )}
                </p>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

function ItemInformationSection(
  toggleCollapse: (number: number) => void,
  lists: number[],
  listing: Listing,
  zoomImage: (image: ImageType) => void,
  categoryName: string,
  dataEditingRepository: any,
) {
  return (
    <div className="grid-column">
      <button
        style={{ fontFamily: Fonts.secondary }}
        onClick={() => toggleCollapse(SECTIONS.ITEM_INFORMATION)}
      >
        ITEM INFORMATION
        <span>
          {lists.includes(SECTIONS.ITEM_INFORMATION) ? (
            <Icon icon="akar-icons:chevron-up" />
          ) : (
            <Icon icon="akar-icons:chevron-down" />
          )}
        </span>
      </button>
      <AnimatePresence initial={false}>
        {lists.includes(SECTIONS.ITEM_INFORMATION) && (
          <motion.div
            className="dataPanel"
            initial="closed"
            animate="open"
            exit="closed"
            variants={{
              open: { opacity: 1, height: 'auto' },
              closed: { opacity: 0, height: 0 },
            }}
            transition={{
              duration: 0.3,
              ease: [0.4, 0.62, 0.23, 0.4],
            }}
          >
            <div className="customer-info row-2 secondary-font">
              <div className="row">
                <p className="left-column">Item name </p>
                <UpdateNameOrDescriptionModal
                  listing={listing as any}
                  dataEditingRepository={dataEditingRepository}
                  typeOfText="name"
                  onUpdated={async () => {
                    toast.success(
                      'Name updated successfully, refresh page (or move to prev/next request) to see changes',
                    );
                  }}
                  children={
                    <div style={{ position: 'relative' }}>
                      <p className="right-column">{listing?.name_en}</p>
                      {dataEditingRepository && (
                        <FaPencil
                          className="cursor-pointer"
                          color="gray"
                          style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                          }}
                        />
                      )}
                    </div>
                  }
                />
              </div>
              <div className="row">
                <p className="left-column">Item name (2nd language)</p>
                <UpdateNameOrDescriptionModal
                  listing={listing as any}
                  dataEditingRepository={dataEditingRepository}
                  typeOfText="name"
                  onUpdated={async () => {
                    toast.success(
                      'Name updated successfully, refresh page (or move to prev/next request) to see changes',
                    );
                  }}
                  children={
                    <div style={{ position: 'relative' }}>
                      <p
                        className="right-column"
                        style={{
                          color: listing?.name_ar === undefined ? 'red' : '',
                        }}
                      >
                        {listing?.name_ar ?? 'Not Provided'}
                      </p>
                      {dataEditingRepository && (
                        <FaPencil
                          className="cursor-pointer"
                          color="gray"
                          style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                          }}
                        />
                      )}
                    </div>
                  }
                />
              </div>
              <div className="row">
                <p className="left-column">Store ID </p>
                <p className="right-column">{listing?.store_id}</p>
              </div>
              <div className="row">
                <p className="left-column">Category</p>
                <p className="right-column">{categoryName}</p>{' '}
                {/* TODO localize */}
              </div>
              <div className="row">
                <p className="left-column">Current orders</p>
                <p className="right-column">{listing?.current_orders}</p>
              </div>
              <div className="row">
                <p className="left-column">Current watchers</p>
                <p className="right-column">{listing?.watchers}</p>
              </div>
              <div
                className="row"
                style={{
                  maxHeight: '500px',
                  border: '1px dashed lightgray',
                  overflow: 'auto',
                }}
              >
                <p className="left-column">About the item (ENGLISH)</p>
                <UpdateNameOrDescriptionModal
                  listing={listing as any}
                  dataEditingRepository={dataEditingRepository}
                  typeOfText="description"
                  onUpdated={async () => {
                    toast.success(
                      'Description updated successfully, refresh page (or move to prev/next request) to see changes',
                    );
                  }}
                  children={
                    <div style={{ position: 'relative' }}>
                      <SanitizedHTMLStyle
                        style={{
                          direction: 'ltr',
                        }}
                        dangerouslySetInnerHTML={sanitizeHTML(
                          listing?.rich_text_description_en,
                        )}
                      />
                      {dataEditingRepository && (
                        <FaPencil
                          className="cursor-pointer"
                          color="gray"
                          style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                          }}
                        />
                      )}
                    </div>
                  }
                />
              </div>
              <div style={{ height: '20px' }} />
              <div
                className="row"
                style={{
                  maxHeight: '500px',
                  border: '1px dashed lightgray',
                  overflow: 'auto',
                }}
              >
                <p className="left-column">About the item (عربي)</p>
                <UpdateNameOrDescriptionModal
                  listing={listing as any}
                  dataEditingRepository={dataEditingRepository}
                  typeOfText="description"
                  onUpdated={async () => {
                    toast.success(
                      'Description updated successfully, refresh page (or move to prev/next request) to see changes',
                    );
                  }}
                  children={
                    <div style={{ position: 'relative' }}>
                      <SanitizedHTMLStyle
                        style={{
                          direction: 'rtl',
                        }}
                        dangerouslySetInnerHTML={sanitizeHTML(
                          listing?.rich_text_description_ar,
                        )}
                      />
                      {dataEditingRepository && (
                        <FaPencil
                          className="cursor-pointer"
                          color="gray"
                          style={{
                            position: 'absolute',
                            top: '10px',
                            left: '10px',
                          }}
                        />
                      )}
                    </div>
                  }
                />
              </div>{' '}
              <div
                style={{
                  height: '10px',
                }}
              />
              <div className="row">
                <p className="left-column">Photos</p>
                <div className="right-column">
                  <div className="images">
                    {listing?.images?.map((image) => {
                      return (
                        <ShowImage
                          image={image}
                          key={image.id}
                          onClick={() => zoomImage(image)}
                          style={{
                            height: '50px',
                            width: '50px',
                            borderRadius: '5px',
                            border:
                              image.id === listing.cover_image_id
                                ? '2px dashed #00b074'
                                : '1px solid lightgray',
                          }}
                        />
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

function AttributesSection(
  toggleCollapse: (number: number) => void,
  categoriesRepository: any,
  lists: number[],
  listing: Listing,
  zoomImage: (image: ImageType) => void,
) {
  const [confirmModal, setConfirmModal] = useState(false);
  const [_, setWantsToChangeToAnotherValue] = useState(false);
  const [showAppendAttributeValuesModal, setShowAppendAttributeValuesModal] =
    useState(false);
  const [attributesFullObjectsMap, setAttributesFullObjectsMap] = useState<
    Record<
      string,
      BaseSelectAttribute | BaseNumericAttribute | BaseBooleanAttribute
    >
  >({});

  const [attributeToUpdate, setAttributeToUpdate] = useState<
    BaseSelectAttribute | BaseNumericAttribute | BaseBooleanAttribute
  >();
  const [arAttributeValue, setArAttributeValue] = useState<string>('');
  const [enAttributeValue, setEnAttributeValue] = useState<string>('');
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  useEffect(() => {
    const fetchAttributesInfo = async () => {
      await SharedRepository.getOfficialValuesOfAttributes(
        Object.keys(listing?.official_attributes || {}).map((key) =>
          parseInt(key),
        ),
      ).then((res: any) => {
        if (!res) return;
        const map: Record<number, any> = {};
        res.forEach((attr: any) => {
          map[attr.id as number] = attr;
        });
        setAttributesFullObjectsMap(map);
      });
    };
    fetchAttributesInfo();
  }, [listing?.id]);
  async function submitNewValues() {
    if (!attributeToUpdate) {
      toast.warn('Please select an attribute');
      return;
    }

    // Check if attribute is of type SELECT and if so, check official values
    if (isSelectAttribute(attributeToUpdate)) {
      if (!enAttributeValue || !arAttributeValue) {
        toast.warn('Please fill in both fields');
        return;
      }

      if (
        attributeToUpdate.official_values_en?.includes(enAttributeValue) ||
        attributeToUpdate.official_values_ar?.includes(arAttributeValue)
      ) {
        setConfirmModal(true);
        toast.warn(
          'This value already exists in the attribute values, click confirm to change to an existing one.',
        );
        return;
      }

      await categoriesRepository
        .appendSelectAttributeValues(
          attributeToUpdate.id,
          [enAttributeValue],
          [arAttributeValue],
        )
        .then(async (res: any) => {
          if (!res) return;

          await categoriesRepository
            .bulkEditAttributes(
              [
                {
                  listing_id: listing!.id,
                  new_value_en: enAttributeValue,
                },
              ],
              attributeToUpdate.id,
              attributeToUpdate.type,
            )
            .then((res: any) => {
              if (!res) return;
              setArAttributeValue('');
              setEnAttributeValue('');
              setAttributeToUpdate(undefined);
              setShowAppendAttributeValuesModal(false);
              toast.success('Attribute updated successfully!');
            })
            .catch(() => {
              toast.error('Failed to update attribute.');
            });
        })
        .catch(() => {
          toast.error('Failed to append attribute values.');
        });

      return;
    }

    // Handle other attribute types (BOOLEAN, NUMERIC) as before...
    if (attributeToUpdate.type === AttributeType.BOOLEAN) {
      if (enAttributeValue !== 'true' && enAttributeValue !== 'false') {
        toast.warn('Please enter a valid boolean value (true or false)');
        return;
      }
    } else if (attributeToUpdate.type === AttributeType.NUMERIC) {
      if (isNaN(Number(enAttributeValue))) {
        toast.warn('Please enter a valid numeric value');
        return;
      }
    }

    // Process for other types like BOOLEAN and NUMERIC...
    let newValue: string | number | boolean = enAttributeValue;
    if (attributeToUpdate.type === AttributeType.BOOLEAN) {
      newValue = enAttributeValue === 'true';
    } else if (attributeToUpdate.type === AttributeType.NUMERIC) {
      newValue = Number(enAttributeValue);
    }

    const payload = [
      {
        listing_id: listing!.id,
        new_value_en: newValue,
      },
    ];

    await categoriesRepository
      .bulkEditAttributes(payload, attributeToUpdate.id, attributeToUpdate.type)
      .then((res: any) => {
        if (res) {
          setArAttributeValue('');
          setEnAttributeValue('');
          setAttributeToUpdate(undefined);
          setShowAppendAttributeValuesModal(false);
          toast.success('Attribute updated successfully!');
        }
      })
      .catch(() => {
        toast.error('Failed to update attribute.');
      });
  }

  function isSelectAttribute(attribute: any): attribute is BaseSelectAttribute {
    return (
      attribute &&
      'official_values_en' in attribute &&
      'official_values_ar' in attribute
    );
  }
  return (
    <div className="grid-column">
      <button
        style={{ fontFamily: Fonts.secondary }}
        onClick={() => toggleCollapse(SECTIONS.ATTRIBUTES)}
      >
        ATTRIBUTES
        <span>
          {lists.includes(SECTIONS.ATTRIBUTES) ? (
            <Icon icon="akar-icons:chevron-up" />
          ) : (
            <Icon icon="akar-icons:chevron-down" />
          )}
        </span>
      </button>
      <AnimatePresence initial={false}>
        {lists.includes(SECTIONS.ATTRIBUTES) && (
          <motion.div
            className="dataPanel"
            initial="closed"
            animate="open"
            exit="closed"
            variants={{
              open: { opacity: 1, height: 'auto' },
              closed: { opacity: 0, height: 0 },
            }}
            transition={{
              duration: 0.3,
              ease: [0.4, 0.62, 0.23, 0.4],
            }}
          >
            <div className="customer-info secondary-font center-text">
              <div className="row">
                <p className="right-column header">Attribute Name</p>
                <p className="right-column header">Attribute value(s)</p>
                <p className="third-column header">Images</p>
                <p className="third-column header">Added By</p>
              </div>
              <div className="row">
                {Object.keys(listing?.official_attributes || {}).map(
                  (keyName, index) => {
                    const obj = listing?.official_attributes[
                      keyName as any
                    ] as AttributeAssociation;
                    const relevantAttribute =
                      attributesFullObjectsMap[obj.attr_id];
                    const imageSet = new Set();
                    return (
                      <Fragment key={index}>
                        <p className="left-column tab">
                          {formatAttributeName(
                            obj.attr_name_en,
                            obj.attr_name_ar,
                          )}
                          {obj?.attribute_full_object?.unit && (
                            <span
                              style={{
                                fontWeight: 'bold',
                              }}
                            >
                              {' (' + obj?.attribute_full_object?.unit + ')'}
                            </span>
                          )}
                        </p>
                        <div className="right-column tab">
                          {getUniqueValues(obj).map((item, i) => {
                            if (
                              isSelectAttribute(relevantAttribute) &&
                              obj.attribute_full_object.type ===
                                AttributeType.SELECT
                            ) {
                              const itemEn = item
                                .split(EN_AR_TRANSLATION_SPLIT_CHAR)[0]
                                ?.trim();
                              const itemAr = item
                                .split(EN_AR_TRANSLATION_SPLIT_CHAR)[1]
                                ?.trim();
                              const isOfficialEn =
                                relevantAttribute.official_values_en.includes(
                                  itemEn,
                                );
                              const isOfficialAr =
                                relevantAttribute.official_values_ar.includes(
                                  itemAr,
                                );

                              if (!isOfficialEn || !isOfficialAr) {
                                return (
                                  <span
                                    title="This value is not official, click to add it to the official values"
                                    key={i}
                                    style={{
                                      color: Colors.blue,
                                      fontWeight: 'bold',
                                      cursor: 'pointer',
                                    }}
                                    onClick={() => {
                                      setAttributeToUpdate(
                                        attributesFullObjectsMap[obj.attr_id],
                                      );
                                      setEnAttributeValue(itemEn);
                                      setArAttributeValue(itemAr);
                                      setShowAppendAttributeValuesModal(true);
                                      onOpen();
                                    }}
                                  >
                                    {item}{' '}
                                  </span>
                                );
                              }
                              return (
                                <div
                                  key={i}
                                  style={{
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => {
                                    setAttributeToUpdate(
                                      attributesFullObjectsMap[obj.attr_id],
                                    );
                                    setEnAttributeValue(itemEn);
                                    setArAttributeValue(itemAr);
                                    setShowAppendAttributeValuesModal(true);
                                    onOpen();
                                  }}
                                >
                                  {item}{' '}
                                </div>
                              );
                            }
                            if (
                              obj.attribute_full_object.type ===
                              AttributeType.BOOLEAN
                            ) {
                              return (
                                <div
                                  title="This value is not official, click to add it to the official values"
                                  key={i}
                                  style={{
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => {
                                    setAttributeToUpdate(
                                      obj.attribute_full_object as any,
                                    );
                                    setEnAttributeValue(item);
                                    setShowAppendAttributeValuesModal(true);
                                    onOpen();
                                  }}
                                >
                                  {item}{' '}
                                </div>
                              );
                            }
                            if (
                              obj.attribute_full_object.type ===
                              AttributeType.NUMERIC
                            ) {
                              return (
                                <div
                                  title="This value is not official, click to add it to the official values"
                                  key={i}
                                  style={{
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => {
                                    setAttributeToUpdate(
                                      obj.attribute_full_object as any,
                                    );
                                    setEnAttributeValue(item);

                                    setShowAppendAttributeValuesModal(true);
                                    onOpen();
                                  }}
                                >
                                  {item}{' '}
                                </div>
                              );
                            }
                          })}
                        </div>
                        <div className="third-column">
                          <div className="images">
                            {obj.values_images_items?.map((item, j) => {
                              if (imageSet.has(item.value_en)) {
                                return;
                              }
                              imageSet.add(item.value_en);
                              return (
                                <Fragment key={j}>
                                  {!item.image || item.image === null ? (
                                    <p>N/A-</p>
                                  ) : (
                                    <ShowImage
                                      image={item.image}
                                      onClick={() => {
                                        zoomImage(
                                          listing?.images?.find(
                                            (i) => i.id === item.image?.id,
                                          )!,
                                        );
                                      }}
                                    />
                                  )}
                                </Fragment>
                              );
                            })}
                          </div>
                        </div>
                        <p
                          className="forth-column tab"
                          style={{
                            color: Colors.greenMain,
                          }}
                        >
                          SILAL
                        </p>
                      </Fragment>
                    );
                  },
                )}
                {Object.keys(listing?.custom_attributes || {}).map(
                  (keyName) => {
                    const obj = listing?.custom_attributes[
                      keyName as any
                    ] as AttributeAssociation;
                    const imageSet = new Set();
                    return (
                      <>
                        <p className="left-column tab">
                          {formatAttributeName(
                            obj.attr_name_en,
                            obj.attr_name_ar,
                          )}
                        </p>
                        <div className="right-column tab">
                          {getUniqueValues(obj).map((item, k) => {
                            return <Fragment key={k}>{item}, </Fragment>;
                          })}
                        </div>
                        <div className="third-column">
                          <div className="images">
                            {obj.values_images_items?.map((item, l) => {
                              if (imageSet.has(item.value_en)) {
                                return;
                              }
                              imageSet.add(item.value_en);
                              return (
                                <Fragment key={l}>
                                  {!item.image || item.image === null ? (
                                    <p>N/A-</p>
                                  ) : (
                                    <ShowImage
                                      image={item.image}
                                      onClick={() =>
                                        zoomImage(
                                          listing?.images?.find(
                                            (i) => i.id === item.image?.id,
                                          )!,
                                        )
                                      }
                                    />
                                  )}
                                </Fragment>
                              );
                            })}
                          </div>
                        </div>
                        <p className="forth-column tab">Store</p>
                      </>
                    );
                  },
                )}
              </div>
              {Object.keys(listing?.custom_attributes || {}).length +
                Object.keys(listing?.official_attributes || {}).length <
                1 && (
                <h5
                  style={{
                    padding: '10px',
                    background: 'white',
                    color: Colors.blueMain,
                    borderRadius: '5px',
                    fontSize: '14px',
                  }}
                >
                  No Attributes Were Given For This Item
                </h5>
              )}
            </div>
            {categoriesRepository && showAppendAttributeValuesModal && (
              <>
                <Modal
                  isOpen={isOpen}
                  size={'xl'}
                  placement={'center'}
                  onOpenChange={onOpenChange}
                >
                  <ModalContent>
                    {(onClose) => (
                      <>
                        <ModalHeader className="flex flex-col gap-1">
                          <h4>Append Attribute Values</h4>
                        </ModalHeader>
                        <ModalBody>
                          <h6 style={{ color: 'green' }}>
                            Enter the new values
                          </h6>
                          <Row>
                            {attributeToUpdate?.type ===
                            AttributeType.BOOLEAN ? (
                              <div className="d-flex align-items-center gap-2">
                                <label>Boolean Value:</label>
                                <Switch
                                  isSelected={enAttributeValue === 'true'}
                                  onChange={(e) =>
                                    setEnAttributeValue(
                                      e.target.checked ? 'true' : 'false',
                                    )
                                  }
                                  color="success"
                                />
                              </div>
                            ) : attributeToUpdate?.type ===
                              AttributeType.NUMERIC ? (
                              <Input
                                className="max-w-xs"
                                label="Enter Number"
                                color="success"
                                variant="bordered"
                                placeholder={enAttributeValue}
                                autoFocus
                                // Add listener for Enter key to submit
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter') {
                                    submitNewValues();
                                  }
                                }}
                                type="number"
                                onChange={(e) =>
                                  setEnAttributeValue(e.target.value)
                                }
                              />
                            ) : (
                              <>
                                {' '}
                                <Col
                                  lg={6}
                                  className="mb-2 d-flex flex-column justify-content-center gap-2"
                                >
                                  {isSelectAttribute(attributeToUpdate) && (
                                    <Autocomplete
                                      className="max-w-xs"
                                      color={'success'}
                                      variant={'bordered'}
                                      label="Select English Value"
                                      allowsCustomValue={true}
                                      autoFocus
                                      placeholder="Search or select a value"
                                      onSelectionChange={(key) => {
                                        const selectedIndex = Number(key);
                                        const selectedEnValue =
                                          attributeToUpdate
                                            ?.official_values_en?.[
                                            selectedIndex
                                          ];
                                        const selectedArValue =
                                          attributeToUpdate
                                            ?.official_values_ar?.[
                                            selectedIndex
                                          ];

                                        if (selectedEnValue) {
                                          setEnAttributeValue(selectedEnValue);
                                        }
                                        if (selectedArValue) {
                                          setArAttributeValue(selectedArValue);
                                        }
                                      }}
                                      onInputChange={(e: string) => {
                                        setEnAttributeValue(e);
                                      }}
                                    >
                                      {(
                                        attributeToUpdate?.official_values_en ??
                                        []
                                      ).map((value, index) => (
                                        <AutocompleteItem
                                          key={index.toString()}
                                          color={'success'}
                                          variant={'shadow'}
                                        >
                                          {value}
                                        </AutocompleteItem>
                                      ))}
                                    </Autocomplete>
                                  )}
                                </Col>
                                <Col
                                  lg={6}
                                  className="mb-2 d-flex flex-column justify-content-center gap-2"
                                >
                                  {isSelectAttribute(attributeToUpdate) && (
                                    <Autocomplete
                                      className="max-w-xs"
                                      label="Select Arabic Value"
                                      color={'success'}
                                      variant={'bordered'}
                                      inputValue={arAttributeValue}
                                      allowsCustomValue={true}
                                      placeholder="Search or select a value"
                                      onSelectionChange={(key) => {
                                        const selectedIndex = Number(key);
                                        const selectedEnValue =
                                          attributeToUpdate
                                            ?.official_values_en?.[
                                            selectedIndex
                                          ];
                                        const selectedArValue =
                                          attributeToUpdate
                                            ?.official_values_ar?.[
                                            selectedIndex
                                          ];

                                        if (selectedArValue) {
                                          setArAttributeValue(selectedArValue);
                                        }
                                        if (selectedEnValue) {
                                          setEnAttributeValue(selectedEnValue);
                                        }
                                      }}
                                      onInputChange={(e: string) => {
                                        setArAttributeValue(e);
                                      }}
                                    >
                                      {(
                                        attributeToUpdate?.official_values_ar ??
                                        []
                                      ).map((value, index) => (
                                        <AutocompleteItem
                                          key={index.toString()}
                                          color={'success'}
                                          variant={'shadow'}
                                        >
                                          {value}
                                        </AutocompleteItem>
                                      ))}
                                    </Autocomplete>
                                  )}
                                </Col>
                              </>
                            )}
                          </Row>
                        </ModalBody>
                        <ModalFooter>
                          <Button
                            color="danger"
                            variant="light"
                            onPress={() => {
                              setArAttributeValue('');
                              setEnAttributeValue('');
                              setAttributeToUpdate(undefined);
                              setShowAppendAttributeValuesModal(false);

                              onClose();
                            }}
                          >
                            Close
                          </Button>
                          <Button
                            color="success"
                            variant="shadow"
                            onPress={() => {
                              submitNewValues();
                            }}
                          >
                            {attributeToUpdate?.type === AttributeType.BOOLEAN
                              ? `Update to ${enAttributeValue}`
                              : attributeToUpdate?.type ===
                                  AttributeType.NUMERIC
                                ? `Update to ${enAttributeValue}`
                                : isSelectAttribute(attributeToUpdate) &&
                                    'official_values_en' in attributeToUpdate &&
                                    attributeToUpdate.official_values_en?.includes(
                                      enAttributeValue,
                                    )
                                  ? `Update ${enAttributeValue} ${EN_AR_TRANSLATION_SPLIT_CHAR} ${arAttributeValue}`
                                  : `Append ${enAttributeValue} ${EN_AR_TRANSLATION_SPLIT_CHAR} ${arAttributeValue}`}
                          </Button>
                        </ModalFooter>
                      </>
                    )}
                  </ModalContent>
                </Modal>
              </>
            )}
            <PopupWithConfirmation
              headerTitle="Do you want to change the value to another EXISTING one?"
              bodyText="This will essentially bulk edit from the current value to the selected existing one."
              buttonTwoText="Yes"
              buttonOneText="No"
              open={confirmModal}
              withTimerOfNSeconds={null}
              onButtonOneClick={() => {
                setWantsToChangeToAnotherValue(false);
                setConfirmModal(false);
              }}
              onButtonTwoClick={async () => {
                await categoriesRepository
                  .bulkEditAttributes(
                    [
                      {
                        listing_id: listing!.id,
                        new_value_en: enAttributeValue,
                      },
                    ],
                    attributeToUpdate?.id,
                    attributeToUpdate?.type,
                  )
                  .then((res: any) => {
                    if (!res) return;
                    setArAttributeValue('');
                    setEnAttributeValue('');
                    setAttributeToUpdate(undefined);
                    setShowAppendAttributeValuesModal(false);
                    setWantsToChangeToAnotherValue(false);
                    setConfirmModal(false);
                  });
              }}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

function CombinationTableSection(
  toggleCollapse: (number: number) => void,
  lists: number[],
  same_attributes: string[],
  listing: Listing,
  handleChangeInStockAndPrice: (
    item: ListingItem,
    price?: string,
    inStock?: boolean,
  ) => void,
  zoomImage: (image: ImageType) => void,
  viewOnly: boolean,
) {
  return (
    <div className="grid-column">
      <button
        style={{ fontFamily: Fonts.secondary }}
        onClick={() => toggleCollapse(SECTIONS.COMBINATION_TABLE)}
      >
        COMBINATION TABLE
        <span>
          {lists.includes(SECTIONS.COMBINATION_TABLE) ? (
            <Icon icon="akar-icons:chevron-up" />
          ) : (
            <Icon icon="akar-icons:chevron-down" />
          )}
        </span>
      </button>
      <AnimatePresence initial={false}>
        {lists.includes(SECTIONS.COMBINATION_TABLE) && (
          <motion.div
            className="dataPanel"
            initial="closed"
            animate="open"
            exit="closed"
            variants={{
              open: { opacity: 1, height: 'auto' },
              closed: { opacity: 0, height: 0 },
            }}
            transition={{
              duration: 0.3,
              ease: [0.4, 0.62, 0.23, 0.4],
            }}
          >
            <div className="customer-info row">
              <span className="my-2">
                All <span className="green">VALID</span> Combinations of
                attributes that have <span className="green">multiple</span>{' '}
                values
              </span>

              <div className="row-3">
                <motion.table
                  className="combination-table"
                  style={{ fontFamily: Fonts.secondary }}
                >
                  <thead>
                    <tr>
                      <th>ID</th>
                      {same_attributes?.map((attr, index) => {
                        return <th key={index}>{attr}</th>;
                      })}
                      <th>Current Price</th>
                      <th>Original Price</th>
                      <th>Image</th>
                      <th>In Stock</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listing?.items?.map((combination, index) => {
                      return (
                        <tr key={index}>
                          <td>#{combination.id}</td>
                          <>
                            {same_attributes?.map((attr, index) => {
                              const attr_value = combination.attributes?.filter(
                                (i) => i.attr_name_en === attr,
                              )[0].attr_value_en;
                              const attr_type = combination.attributes?.filter(
                                (i) => i.attr_name_en === attr,
                              )[0].attribute_type;
                              return (
                                <td key={index}>
                                  {attr_type === AttributeType.BOOLEAN
                                    ? JSON.stringify(attr_value)
                                    : attr_type === AttributeType.NUMERIC
                                      ? formatDecimals(attr_value as string)
                                      : attr_value}
                                </td>
                              );
                            })}

                            {canChangeStockAndPrice(listing) ? (
                              <td className="d-flex justify-content-center">
                                <input
                                  type="number"
                                  className="form-control"
                                  style={{
                                    width: '100px',
                                    height: '30px',
                                  }}
                                  defaultValue={combination.price}
                                  disabled={true}
                                />
                              </td>
                            ) : (
                              <td>{formatPrice(combination.price)}</td>
                            )}
                            {canChangeStockAndPrice(listing) ? (
                              <td className="d-flex justify-content-center">
                                <input
                                  type="number"
                                  className="form-control"
                                  style={{
                                    width: '100px',
                                    height: '30px',
                                  }}
                                  defaultValue={combination.original_price}
                                  disabled={viewOnly}
                                  onBlur={(e) =>
                                    handleChangeInStockAndPrice(
                                      combination,
                                      e.target.value,
                                      combination.in_stock,
                                    )
                                  }
                                />
                              </td>
                            ) : (
                              <td>{formatPrice(combination.original_price)}</td>
                            )}
                          </>

                          <td
                            style={{
                              border: 'none',
                            }}
                          >
                            {combination.image ? (
                              <div
                                className="images"
                                style={{
                                  height: '50px',
                                  width: '50px',
                                }}
                                onClick={() => zoomImage(combination.image)}
                              >
                                <ShowImage
                                  style={{
                                    height: '50px',
                                    width: '50px',
                                    border: '1px solid lightgray',
                                    borderRadius: '5px',
                                  }}
                                  image={combination.image}
                                />
                              </div>
                            ) : (
                              <></>
                            )}
                          </td>
                          <td>
                            <div className="form-check flex">
                              {canChangeStockAndPrice(listing) ? (
                                <input
                                  type="checkbox"
                                  checked={combination.in_stock}
                                  disabled={viewOnly}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>,
                                  ) =>
                                    handleChangeInStockAndPrice(
                                      combination,
                                      undefined,
                                      e.target.checked,
                                    )
                                  }
                                />
                              ) : (
                                <>{combination.in_stock ? 'Yes' : 'No'}</>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </motion.table>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

function PromotionSection(
  toggleCollapse: (number: number) => void,
  lists: number[],
  listing: Listing,
) {
  const appliedPromotion =
    listing.items?.find((item) => item.applied_promotion)?.applied_promotion ||
    null;
  return (
    <div className="grid-column">
      <button
        style={{ fontFamily: Fonts.secondary }}
        onClick={() => toggleCollapse(SECTIONS.PROMOTION)}
      >
        CURRENTLY APPLIED PROMOTION
        <span>
          {lists.includes(SECTIONS.PROMOTION) ? (
            <Icon icon="akar-icons:chevron-up" />
          ) : (
            <Icon icon="akar-icons:chevron-down" />
          )}
        </span>
      </button>
      <AnimatePresence initial={false}>
        {lists.includes(SECTIONS.PROMOTION) && (
          <motion.div
            className="dataPanel"
            initial="closed"
            animate="open"
            exit="closed"
            variants={{
              open: { opacity: 1, height: 'auto' },
              closed: { opacity: 0, height: 0 },
            }}
            transition={{
              duration: 0.3,
              ease: [0.4, 0.62, 0.23, 0.4],
            }}
          >
            {appliedPromotion ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px',
                  border: '1px solid #b2dfdb',
                  borderRadius: '8px',
                  margin: '16px 0',
                  padding: '16px',
                  background: '#e8f5e9',
                  boxShadow: '0 2px 8px #e0f2f1',
                }}
              >
                <ShowImage
                  image={appliedPromotion.image}
                  style={{
                    width: 60,
                    height: 60,
                    borderRadius: 8,
                    objectFit: 'cover',
                    border: '1px solid #b2dfdb',
                  }}
                />
                <div style={{ flex: 1 }}>
                  <div
                    style={{ fontWeight: 600, fontSize: 16, color: '#00796b' }}
                  >
                    {appliedPromotion.name_en} / {appliedPromotion.name_ar}
                  </div>
                  <div
                    style={{ fontSize: 13, color: '#388e3c', margin: '2px 0' }}
                  >
                    {appliedPromotion.promotion_type_name} |{' '}
                    {appliedPromotion.discount_type_name}
                  </div>
                  <div style={{ fontSize: 13, color: '#388e3c' }}>
                    Discount:{' '}
                    {appliedPromotion.discount_type === DiscountType.Percentage
                      ? `%${parseFloat(appliedPromotion.discount_value) * 100}`
                      : formatPrice(appliedPromotion.discount_value)}
                    {appliedPromotion.max_discount_amount
                      ? `, Max: ${formatPrice(appliedPromotion.max_discount_amount)}`
                      : ''}
                  </div>
                  <div style={{ fontSize: 12, color: '#388e3c' }}>
                    {new Date(appliedPromotion.start_date).toLocaleDateString()}{' '}
                    - {new Date(appliedPromotion.end_date).toLocaleDateString()}
                  </div>
                  <div style={{ fontSize: 12, color: '#388e3c' }}>
                    {appliedPromotion.requires_coupon
                      ? 'Coupon Required'
                      : 'No Coupon Required'}
                  </div>
                </div>
                {appliedPromotion.disabled && (
                  <span
                    style={{ color: '#d32f2f', fontWeight: 600, fontSize: 13 }}
                  >
                    Inactive
                  </span>
                )}
                {appliedPromotion.is_active_now && (
                  <span
                    style={{ color: '#388e3c', fontWeight: 600, fontSize: 13 }}
                  >
                    Active
                  </span>
                )}
              </div>
            ) : (
              <div
                style={{ padding: '16px', color: '#888', fontStyle: 'italic' }}
              >
                No promotion is currently applied to this listing.
              </div>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

function ShippingSection(
  toggleCollapse: (number: number) => void,
  lists: number[],
  listing: Listing,
) {
  return (
    <div className="grid-column">
      <button
        style={{ fontFamily: Fonts.secondary }}
        onClick={() => toggleCollapse(SECTIONS.SHIPPING)}
      >
        SHIPPING
        <span>
          {lists.includes(SECTIONS.SHIPPING) ? (
            <Icon icon="akar-icons:chevron-up" />
          ) : (
            <Icon icon="akar-icons:chevron-down" />
          )}
        </span>
      </button>
      <AnimatePresence initial={false}>
        {lists.includes(SECTIONS.SHIPPING) && (
          <motion.div
            className="dataPanel"
            initial="closed"
            animate="open"
            exit="closed"
            variants={{
              open: { opacity: 1, height: 'auto' },
              closed: { opacity: 0, height: 0 },
            }}
            transition={{
              duration: 0.3,
              ease: [0.4, 0.62, 0.23, 0.4],
            }}
          >
            <div className="customer-info row-2 secondary-font">
              <div className="row">
                <p className="left-column">What’s in Box</p>
                <p className="right-column">{listing?.whats_included}</p>
              </div>
              <div className="row">
                <p className="left-column">Condition</p>
                <p className="right-column">
                  {listing?.is_used ? 'Used' : 'New'}
                </p>
              </div>
              <div className="row">
                <p className="left-column">Package Dimensions </p>
                <p className="right-column">
                  Width: {formatDecimals(listing?.width)}
                  cm - Depth: {formatDecimals(listing?.length)}
                  cm - Height: {formatDecimals(listing?.height)}
                  cm
                </p>
              </div>
              <div className="row">
                <p className="left-column">Item qualities</p>
                <p className="right-column">
                  {listing?.fragile ||
                  listing?.keep_dry ||
                  listing?.flammable ? (
                    <>
                      {listing?.fragile && 'Breakable, '}
                      {listing?.keep_dry && 'Keep Dry, '}
                      {listing?.flammable && 'Flammable'}
                    </>
                  ) : (
                    'None'
                  )}
                </p>
              </div>

              <div className="row">
                <p className="left-column">Package Weight</p>
                <p className="right-column">
                  {formatDecimals(listing?.weight)}
                  gram
                </p>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export const getUniqueValues = (obj: AttributeAssociation) => {
  const results: string[] = [];
  obj.values_images_items?.map((item) => {
    const val =
      typeof item.value_en === 'boolean'
        ? JSON.stringify(item.value_en)
        : !isNaN(item.value_en as any)
          ? formatDecimals(item.value_en)
          : formatAttributeValues(
              item.value_en,
              item.value_ar,
              obj.attribute_full_object.type,
            );
    if (val && !results.includes(val)) {
      results.push(val);
    }
    return null;
  });
  return results;
};
